var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('small',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.userInfo.userName))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }